<template>
  <div
    v-if="interaction_expanded"
    class="relative p-4 mb-4 border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
    <div class="flex items-center ml-2">
      <div class="flex items-center">
        <div v-if="interaction.type == 'call'">
          <Phone class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'email'" class="flex">
          <div
            v-if="!interaction.email_opened && (interaction.source == 'gmail' || interaction.source == 'outlook')"
            class="w-3 h-3 mt-2 mr-1 rounded-full bg-gradient-to-r from-status-success-green to-green-400" />
          <Reply v-if="interaction.meta_data.is_sent" class="w-4 h-4 mt-1 rotate-180" />
          <GmailIcon v-if="interaction.origin == 'gmail'" class="w-8 h-8 mr-2" />
          <OutlookIcon v-else-if="interaction.origin == 'outlook'" class="w-8 h-8 mr-2" />
          <Mail v-else-if="interaction.origin != 'gmail' || interaction.origin != 'outlook'" class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'note'">
          <StickyNote class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'marketing'">
          <Megaphone class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'meeting'">
          <GoogleIcon v-if="interaction.origin == 'gmail'" class="w-6 h-6 mr-2" />
          <MicrosoftIcon v-else-if="interaction.origin == 'outlook'" class="w-6 h-6 mr-2" />
          <UsersRound v-else-if="interaction.origin != 'gmail' || interaction.origin != 'outlook'" class="w-4 h-4 mr-2 text-common-grey" />
          <div
            v-if="
              interaction.type == 'meeting' &&
                (interaction.origin == 'gmail' || interaction.origin == 'outlook') &&
                !interaction.meta_data?.conferencing
            "
            class="absolute hidden text-xs italic font-normal lowercase whitespace-nowrap">
            {{ $t("creation in progress...") }}
          </div>
        </div>
        <div v-else-if="interaction.type == 'support'">
          <Wrench class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <p v-if="interaction.origin != 'gmail' && interaction.origin != 'outlook' && interaction?.type">
          {{ interaction?.type[0].toUpperCase() }}{{ interaction.type.slice(1) }}
        </p>
        <div v-if="interaction.origin == 'gmail' || interaction.origin == 'outlook'" :class="['whitespace-nowrap relative']">
          <div :class="['font-medium  has-tooltip', { 'font-extrabold': calculateUnread(interaction) }]">
            {{ interaction?.name?.length > 28 ? interaction?.name.slice(0, 27) + "..." : interaction?.name }}

            <span
              class="inline-flex items-center gap-2 px-2 py-1 font-medium rounded-md tooltip whitespace-nowrap text-md bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
              {{ interaction.name }}</span>
            <span v-if="interaction.children?.length" class="ml-1 text-sm font-light">{{ interaction.children.length }}</span>
          </div>
        </div>
      </div>

      <div class="absolute flex -right-3 -top-3 gap-x-2">
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
          @click="interaction_expanded = !interaction_expanded">
          <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
          <span
            class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            {{ $t("Minimize") }}</span>
        </div>
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
          @click="handleViewInteraction(interaction)">
          <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
          <span
            class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
            {{ $t("View Interaction") }}</span>
        </div>
        <!-- <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleRemoveInteraction(interaction)">
                      <X
                        color="#FF0000"
                        class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          Remove</span>
                    </div> -->
      </div>
    </div>
    <div class="flex w-full mt-5">
      <div class="w-1/3">
        <div class="flex flex-row items-center gap-2 mt-2">
          <div class="text-common-grey">
            {{ $t("Category") }}:
          </div>
          <div>
            {{ interaction.category ? $utils.capitalize(interaction.category.replace("_", " ")) : "-" }}
          </div>
        </div>
      </div>

      <div class="w-1/3">
        <div class="flex flex-row items-center gap-2">
          <div class="text-common-grey whitespace-nowrap">
            {{ $t("Due Date") }}:
          </div>

          <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
            <span v-if="interaction.due_date">
              {{ $moment(interaction.due_date).format("DD MMM  YYYY") }}
            </span>

            <span v-else> - </span>
          </div>
        </div>
      </div>

      <div :class="[`${interaction.users.length > 4 ? 'w-[16%]' : ''}`]" class="ml-auto -mt-8">
        <div :class="[`${interaction.users.length > 4 ? '' : '-ml-10'}`]" class="mb-2 text-common-grey whitespace-nowrap text-start">
          {{ $t("Team Members") }}
        </div>
        <div class="flex items-center -ml-5 -space-x-4 overflow-hidden">
          <span v-for="user in interaction.users.slice(0, 4)" :key="user" class="inline-block has-tooltip">
            <img
              v-if="$utils.getUserById(user, 'avatar')"
              class="inline-block rounded-full h-9 w-9 object-cover"
              :src="$utils.getUserById(user, 'avatar')"
              onerror="this.onerror=null; this.src=window.default_avatar;"
              alt="">
            <Avatar v-else :first-name="$utils.getUserById(user, 'first_name')" :last-name="$utils.getUserById(user, 'last_name')" />
            <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
              <div class="">
                <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                  {{ $utils.getUserById(user, "full_name") }}
                </p>
              </div>
            </span>
          </span>
          <span v-if="interaction.users.length > 4" class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
            + {{ interaction.users.length - 4 }} {{ $t("more") }}</span>
        </div>
      </div>
    </div>
  </div>

  <div
    v-else
    class="relative flex p-4 mb-4 align-middle border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
    <div class="flex items-center ml-2">
      <div class="flex items-center">
        <div v-if="interaction.type == 'call'">
          <Phone class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'email'" class="flex">
          <div
            v-if="!interaction.email_opened && (interaction.source == 'gmail' || interaction.source == 'outlook')"
            class="w-3 h-3 mt-2 mr-1 rounded-full bg-gradient-to-r from-status-success-green to-green-400" />
          <Reply v-if="interaction.meta_data.is_sent" class="w-4 h-4 mt-1 rotate-180" />
          <GmailIcon v-if="interaction.origin == 'gmail'" class="w-8 h-8 mr-2" />
          <OutlookIcon v-else-if="interaction.origin == 'outlook'" class="w-8 h-8 mr-2" />
          <Mail v-else-if="interaction.origin != 'gmail' || interaction.origin != 'outlook'" class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'note'">
          <StickyNote class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'marketing'">
          <Megaphone class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <div v-else-if="interaction.type == 'meeting'">
          <GoogleIcon v-if="interaction.origin == 'gmail'" class="w-6 h-6 mr-2" />
          <MicrosoftIcon v-else-if="interaction.origin == 'outlook'" class="w-6 h-6 mr-2" />
          <UsersRound v-else-if="interaction.origin != 'gmail' || interaction.origin != 'outlook'" class="w-4 h-4 mr-2 text-common-grey" />
          <div
            v-if="
              interaction.type == 'meeting' &&
                (interaction.origin == 'gmail' || interaction.origin == 'outlook') &&
                !interaction.meta_data?.conferencing
            "
            class="absolute hidden text-xs italic font-normal lowercase whitespace-nowrap">
            {{ $t("creation in progress...") }}
          </div>
        </div>
        <div v-else-if="interaction.type == 'support'">
          <Wrench class="w-4 h-4 mr-2 text-common-grey" />
        </div>
        <p v-if="interaction.origin != 'gmail' && interaction.origin != 'outlook' && interaction?.type">
          {{ interaction?.type[0].toUpperCase() }}{{ interaction.type.slice(1) }}
        </p>
        <div v-if="interaction.origin == 'gmail' || interaction.origin == 'outlook'" :class="['whitespace-nowrap relative']">
          <div :class="['font-medium  has-tooltip', { 'font-extrabold': calculateUnread(interaction) }]">
            {{ interaction?.name?.length > 28 ? interaction?.name.slice(0, 27) + "..." : interaction?.name }}

            <span
              class="inline-flex items-center gap-2 px-2 py-1 font-medium rounded-md tooltip whitespace-nowrap text-md bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
              {{ interaction.name }}</span>
            <span v-if="interaction.children?.length" class="ml-1 text-sm font-light">{{ interaction.children.length }}</span>
          </div>
        </div>
      </div>

      <div class="absolute flex -right-3 -top-3 gap-x-2">
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
          @click="interaction_expanded = !interaction_expanded">
          <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
          <span
            class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            {{ $t("Minimize") }}</span>
        </div>
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
          @click="handleViewInteraction(interaction)">
          <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
          <span
            class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
            {{ $t("View Interaction") }}</span>
        </div>
        <!-- <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleRemoveInteraction(interaction)">
                      <X
                        color="#FF0000"
                        class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          Remove</span>
                    </div> -->
      </div>
    </div>

    <div class="absolute flex -right-3 -top-3 gap-x-2">
      <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
        @click="interaction_expanded = !interaction_expanded">
        <div class="w-[15px] h-[15px] ml-[5px] mt-[5px] border-[3px] rounded-md border-[#45D72D]" />
        <span
          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
          {{ $t("Expand") }}</span>
      </div>
      <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
        @click="handleViewInteraction(interaction)">
        <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
        <span
          class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
          {{ $t("View Interaction") }}</span>
      </div>
      <!-- <div
                    class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                    @click="handleRemoveInteraction(interaction)">
                    <X
                      color="#FF0000"
                      class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
                        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        Remove</span>
                  </div> -->
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/shared/Avatar.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { Wrench, Megaphone, Maximize2, Mail, Phone, Reply, UsersRound, StickyNote } from "lucide-vue-next"
import GmailIcon from "@/components/shared/icons/GmailIcon"
import GoogleIcon from "@/components/shared/icons/GoogleIcon"
import OutlookIcon from "@/components/shared/icons/OutlookIcon"
import MicrosoftIcon from "@/components/shared/icons/MicrosoftIcon"

export default {
  components: {
    Maximize2,
    Avatar,
    Phone,
    Mail,
    Reply,
    GmailIcon,
    GoogleIcon,
    OutlookIcon,
    MicrosoftIcon,
    StickyNote,
    Wrench,
    UsersRound,
    Megaphone
  },
  props: { interaction: null },
  emits: [],
  data() {
    return {
      interaction_expanded: false
    }
  },
  watch: {},

  created() {},

  methods: {
    calculateUnread(email) {
      if (email.meta_data?.unread) {
        return true
      }
      if (email.meta_data?.children?.length) {
        email.meta_data?.children.forEach((child_email) => {
          if (child_email?.meta_data.unread) {
            return true
          }
        })
      }
      return false
    },
    handleViewInteraction(interaction) {
      this.$emitter.emit(ALL_EMITTERS.UPDATE_INTERACTION, {
        interaction: this.$utils.clone(interaction)
      })
    }
  }
}
</script>
